
    require('./graphic');
    require('../zrender').registerPainter('vml', require('./Painter'));



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/vml/vml.js
// module id = 404
// module chunks = 1